import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAppIcBefehl27 = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Form",
	xmlns: "http://www.w3.org/2000/svg",
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".black{fill:currentColor;}" }) }), /* @__PURE__ */ _jsx("g", {
		id: "Command_27",
		children: /* @__PURE__ */ _jsx("path", {
			className: "black",
			d: "M7.02,46.99l50.89-29.08c-.92-1.16-2.32-1.91-3.9-1.91H10c-2.76,0-5,2.24-5,5v22c0,1.64.8,3.08,2.02,3.99ZM7,21c0-1.65,1.35-3,3-3h43.74l-12.03,6.87h-3.27v1.87l-3.05,1.74.99-1.24v-2.37h-10.79v2.5h7.11l-3.89,4.87-7.38,4.22h-4.06v-11.59h-2.95v14.13h2.57l-9.59,5.48c-.25-.44-.4-.94-.4-1.48v-22ZM46.05,27.55c.51.21.77.65.77,1.3,0,.59-.19,1.01-.58,1.24-.39.24-.89.35-1.51.35h-3.47v-.72l-2.82,1.61v7.66h6.4c.72,0,1.39-.06,2.01-.19.62-.13,1.15-.36,1.61-.71.4-.3.74-.67,1.01-1.11.42-.66.63-1.42.63-2.25s-.18-1.5-.55-2.07-.91-.98-1.63-1.25c.47-.24.83-.51,1.07-.8.43-.53.65-1.22.65-2.08s-.22-1.56-.65-2.16c-.19-.26-.43-.48-.7-.67l-2.94,1.68c.26.04.5.09.71.16ZM46.18,36.3c-.34.17-.83.25-1.45.25h-3.47v-3.77h3.52c.61,0,1.09.09,1.43.24.61.28.91.78.91,1.52,0,.87-.31,1.46-.94,1.76ZM25.41,38.78l3.98-2.28h7.01v2.49h-10.99v-.22ZM58.81,19.7c.11.42.19.85.19,1.3v22c0,2.76-2.24,5-5,5H10c-.21,0-.41-.04-.61-.06l3.39-1.94h41.22c1.65,0,3-1.35,3-3v-22c0-.09-.02-.17-.03-.25l1.83-1.05Z"
		})
	})]
});
export default SvgAppIcBefehl27;
